$(".custom-modal").click(function () {
  $(".modal-overlay").trigger("click");
});

$(".custom-modal-inner").click(function (e) {
  e.stopPropagation();
});


function setXposition() {
  let md = parseInt($('.modal.custom-modal.open .modal-content').outerWidth());
  let mr = parseInt($('.modal.custom-modal.open .custom-modal-inner').css('margin-left'));
  let mx = parseInt($('.modal.custom-modal.open .custom-modal-inner').css('margin-top'));
  $('.modal.custom-modal.open .modal-close').css({
    'left':
    md + mr - 44
  });
  $('.modal.custom-modal.open .modal-close').css({
    'top':
    mx + 16
  })
}

function exitIntent(type, occurence = 1) {
  let occ = 1;
  let currentMousePos = {y: -1};

  $(document).mousemove(function (event) {
    if (occ <= occurence) {
      currentMousePos.y = event.pageY;
      if (currentMousePos.y < 11) {
         
          $('#'+type).modal('open');
          occ++;
      }
    }
  });
}
$( document ).ready(function() {

  if($("#exitLinkModal").length){
     exitIntent('exitLinkModal')
  }else if($("#exitInfoLetterModal").length){
    exitIntent('exitInfoLetterModal')
  }

});
$('.modal').modal({
    dismissible: true, // Modal can be dismissed by clicking outside of the modal
    opacity: .5, // Opacity of modal background
    in_duration: 300, // Transition in duration
    out_duration: 300, // Transition out duration
    ready: function () {
      setXposition();
    }, // Callback for Modal open
    complete: function () {
    } // Callback for Modal close
  }
);

$(window).resize(function () {
  setXposition();
});

$('.modal-action.modal-close').on('click', function (e) {
  e.preventDefault();
});

/*$('.footer_newslettre-form').on('submit', function (e) {
    e.preventDefault();
    var form = $(this);
     
    $('#statusModal .submit-status').hide();
    $('#statusModal').modal('open').addClass('loading');

    $.ajax({
        type: "POST",
        url: form.attr('action'),
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            dataLayer.push({
              'page': $('meta[name="title"]').attr('content'),
              'event': 'contactSubmit'
            });
            $('#statusModal').removeClass('loading');
            if (data.status == 'success') {
                $('#statusModal .submit-status.failed').hide();
                $('#statusModal .submit-status.success').show();
            } else {
                $('#statusModal .submit-status.failed').show();
                $('#statusModal .submit-status.success').hide();
            }

        },
        fail:function(){
            $('#statusModal').removeClass('loading');
            $('#statusModal .submit-status.failed').show();
            $('#statusModal .submit-status.success').hide();
        },
        error:function(){
           $('#statusModal').removeClass('loading');
            $('#statusModal .submit-status.failed').show();
            $('#statusModal .submit-status.success').hide();
        }
          


    });
  
});*/
